import script from "./TeamInformationPreviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamInformationPreviewPage.vue?vue&type=script&setup=true&lang=js"

import "./TeamInformationPreviewPage.vue?vue&type=style&index=0&id=09cffe88&lang=css"

const __exports__ = script;

export default __exports__